import { useEffect } from "react";
import { useState } from "react";
import { GetRequest } from "../../utils/ApiServices";
function SiteMarquee() {
  const [marqueeStrings, setMarqueeStrings] = useState(null);

  const getData = async () => {
    const res = await GetRequest("banner-details1");
    if (res) {
      setMarqueeStrings(res?.marquee);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    marqueeStrings &&
    marqueeStrings.length > 0 && (
      <div className="marquee-header">
        {marqueeStrings.map((el, i) => {
          return (
            <span
              key={i}
              dangerouslySetInnerHTML={{
                __html: `${el}`,
              }}
            ></span>
          );
        })}
      </div>
    )
  );
}
export default SiteMarquee;
